import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./touchable.css.ts.vanilla.css-mistica.js";
var f = "mhti6u2 _1y2v1nfkk", y = "mhti6u0", _ = "mhti6u5", m = "mhti6u2 _1y2v1nfkk _1y2v1nf7d _1y2v1nf8m _1y2v1nf9v _1y2v1nfb4 _1y2v1nfhm _1y2v1nfk2 _1y2v1nfi7 _1y2v1nf3n _1y2v1nf7c _1y2v1nfkm";
export { f as base, y as marginReset, _ as notTouchable, m as touchable };
